import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { allocationQueries } from '../queries';
import type { AllocationDefaultsParams } from '../types/AllocationDefaults';

/**
 * Busca os padrões sob demanda, no evento de troca de profissional (como o
 * `onChange` do legado), em vez de sincronizar o formulário com um efeito.
 */
export function useAllocationDefaults() {
  const queryClient = useQueryClient();
  return useCallback(
    (params: AllocationDefaultsParams) =>
      queryClient.fetchQuery(allocationQueries.defaults(params)),
    [queryClient],
  );
}
